import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

// VFX: Testimonial Quote Card
// Category: ui-elements · Tags: testimonial, quote, card, review, stars
export default function CardTestimonialQuoteCard900Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const cardSp = spring({ frame, fps, config: { damping: 16, stiffness: 110 } });
  const avSp = spring({ frame: frame - 6, fps, config: { damping: 14, stiffness: 130 } });
  const starsSp = (i: number) => spring({ frame: frame - 12 - i * 2, fps, config: { damping: 12, stiffness: 200 } });
  const quoteSp = spring({ frame: frame - 18, fps, config: { damping: 18, stiffness: 100 } });

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(135deg, #1e293b 0%, #0a0e1a 100%)",
      alignItems: "center", justifyContent: "center", padding: 80
    }}>
      <div style={{
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 28,
        padding: "56px 48px",
        width: 820,
        opacity: cardSp,
        transform: `translateY(${(1 - cardSp) * 40}px) scale(${interpolate(cardSp, [0, 1], [0.95, 1])})`,
        boxShadow: "0 32px 80px rgba(0,0,0,0.5)",
        backdropFilter: "blur(20px)",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 28 }}>
          <div style={{
            width: 88, height: 88, borderRadius: "50%",
            background: "linear-gradient(135deg, #a855f7 0%, #06b6d4 100%)",
            opacity: avSp,
            transform: `scale(${avSp})`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 36, fontWeight: 800, color: "#fff"
          }}>JS</div>
          <div style={{ opacity: avSp }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: "#f8fafc" }}>Julia Souza</div>
            <div style={{ fontSize: 18, color: "#94a3b8" }}>Product Designer · Acme Inc.</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 6, marginBottom: 24 }}>
          {[0, 1, 2, 3, 4].map(i => (
            <span key={i} style={{
              fontSize: 32, color: "#f59e0b",
              opacity: starsSp(i),
              transform: `scale(${starsSp(i)})`,
            }}>★</span>
          ))}
        </div>
        <p style={{
          margin: 0, fontSize: 32, lineHeight: 1.4, color: "#e2e8f0", fontWeight: 400,
          opacity: quoteSp,
          transform: `translateY(${(1 - quoteSp) * 12}px)`,
          fontStyle: "italic"
        }}>"Mudou a forma como nossa equipe trabalha. Inacreditável o quanto ganhamos em velocidade."</p>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
